import { type PropsWithChildren } from "react";

export const Root = ({ children }: Readonly<PropsWithChildren>) => (
  <div
    data-testid="circle-ai-shell-workspace-root"
    className="isolate flex min-h-0 min-w-80 flex-1 flex-col overflow-hidden"
  >
    {children}
  </div>
);

Root.displayName = "CircleAIAppShell.Layout.Workspace";
